/**
 * Wpis historii pracy dotyczący weryfikacji dwuetapowej → klucz tłumaczenia.
 *
 * Kody nadaje backend (poza tym repo) i w tłumaczeniach ich nie było, więc w kolumnie
 * „Akcja" stał surowy kod z bazy — zgłoszone jako `mfa_succes` (błąd 415). Potwierdzony
 * jest tylko ten jeden kod, całej rodziny nie znamy, dlatego reszta dostaje ogólną
 * etykietę rodziny zamiast surowego wpisu z bazy.
 *
 * Czyste funkcje, bez zależności od Angulara — testują się bez TestBed.
 */

/**
 * Rodzina MFA. Ta sama lista rządzi ikoną wiersza w obu widokach historii pracy —
 * dopasowanie po fragmencie, bo pisowni kodów po stronie backendu nie znamy.
 */
const MFA_TOKENS = ['mfa', '2fa', 'otp', 'two_factor', 'twofactor', 'two-factor',
  'authenticator', 'backup_code', 'recovery_code', 'trusted_device'];

/**
 * Kody z własnym tłumaczeniem w sekcji WORK-HISTORY. Gdy backend poda pełną listę,
 * dopisujemy kolejne tutaj i w plikach i18n — to jedyne miejsce, które trzeba ruszyć.
 */
const MFA_LABEL_KEYS: { [action: string]: string } = {
  // Backend zapisuje „succes" przez jedno „s". Gdyby ktoś kiedyś poprawił tam literówkę,
  // obie pisownie mają prowadzić do tego samego tłumaczenia — inaczej wpis wróciłby
  // na ekran jako surowy kod.
  mfa_succes: 'WORK-HISTORY.mfa_succes',
  mfa_success: 'WORK-HISTORY.mfa_succes'
};

/**
 * Ogólna etykieta rodziny — sekcja MFA jest w każdym pliku i18n. Nie mówi, co dokładnie
 * się stało, ale to i tak więcej niż kod z bazy.
 */
export const MFA_FALLBACK_LABEL_KEY = 'MFA.TITLE';

export function isMfaAction(action: string): boolean {
  const a = (action || '').toString().toLowerCase();
  return MFA_TOKENS.some(token => a.indexOf(token) !== -1);
}

/**
 * `null` = wpis nie dotyczy weryfikacji dwuetapowej; wtedy wywołujący zostaje przy
 * swoim dotychczasowym zachowaniu.
 */
export function toMfaActionKey(action: string): string {
  if (!isMfaAction(action)) {
    return null;
  }
  return MFA_LABEL_KEYS[(action || '').toString().toLowerCase()] || MFA_FALLBACK_LABEL_KEY;
}
